<p-confirmDialog header="Confirmar salida" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-toast position="top-right"></p-toast>

<router-outlet></router-outlet>

@if(isLoading) {
<div
  @fadeInOut
  class="fixed w-screen h-screen top-0 left-0 z-[5000] bg-black/10 flex justify-center items-center"
>
  <p-progress-spinner ariaLabel="loading" />
</div>
}

@if(isPdfLoading$ | async) {
  <app-pdf-loading-overlay />
}